export enum ViewTogglerMode {
    ROW = 'row',
    GRID = 'grid'
}

export class ViewToggler {
    public static create(div: HTMLDivElement, mode?: ViewTogglerMode): void {
        const togglerMode = mode ?? this.getTogglerMode(div.dataset.type ?? '');

        div.classList.add(`view-toggler--${togglerMode}`);

        this._addEventListeners(div, togglerMode);
    }

    private static _addEventListeners(element: HTMLElement, mode: ViewTogglerMode): void {
        element.addEventListener('click', (event: MouseEvent) => {
            document.querySelectorAll<HTMLElement>('.view-grid').forEach((e: HTMLElement) => {
                if (mode === ViewTogglerMode.ROW) {
                    e.classList.add('view-toggler--row-mode');
                } else {
                    e.classList.remove('view-toggler--row-mode');
                }
            });

            this._updateStateForAll(mode);
        });
    }

    private static _updateStateForAll(newMode: ViewTogglerMode): void {
        document.querySelectorAll<HTMLElement>('.view-toggler').forEach((e: HTMLElement) => {
            e.classList.remove('view-toggler--grid--active');
            e.classList.remove('view-toggler--row--active');

            if (e.classList.contains('view-toggler--grid')) {
                if (newMode === ViewTogglerMode.GRID) {
                    e.classList.add('view-toggler--grid--active');
                }
            }

            if (e.classList.contains('view-toggler--row')) {
                if (newMode === ViewTogglerMode.ROW) {
                    e.classList.add('view-toggler--row--active');
                }
            }
        });
    }

    public static getTogglerMode(str: string): ViewTogglerMode {
        return (<any>ViewTogglerMode)[str.toUpperCase()];
    }
}
